var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.332 171H297.602C284.758 196.75 277.332 225.656 277.332 256.332C277.332 287.012 284.758 315.918 297.602 341.668H85.332C38.273 341.668 0 303.395 0 256.332C0 209.273 38.273 171 85.332 171Z",
    fill: "#1D61E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256.332C512 338.809 445.14 405.668 362.668 405.668C280.191 405.668 213.332 338.808 213.332 256.332C213.332 173.859 280.192 107 362.668 107C445.141 107 512 173.86 512 256.332Z",
    fill: "#6197FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.668 256.332C426.668 291.68 398.012 320.332 362.668 320.332C327.32 320.332 298.668 291.68 298.668 256.332C298.668 220.988 327.32 192.332 362.668 192.332C398.012 192.332 426.668 220.988 426.668 256.332Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnable);
export default __webpack_public_path__ + "static/media/Enable.7050811a067bbaba5b535e49cbe39d6f.svg";
export { ForwardRef as ReactComponent };